import { IFormBase } from '../typings';
import { useAppSelector } from '@/hooks/use-app-selector';

import { useEffect, useState } from 'react';
import { selectForm } from '../store';

export const useFieldHasAnyValue = (
  fieldId: IFormBase['fieldId'],
): boolean | null => {
  const [hasAnyValue, setHasAnyValue] = useState<boolean | null>(null);

  const { conditionalParentFields, conditionalChildFields } =
    useAppSelector(selectForm);

  useEffect(() => {
    const isParentField = Object.keys(conditionalParentFields).includes(
      fieldId,
    );

    if (!isParentField) {
      setHasAnyValue(conditionalChildFields[fieldId]?.hasAnyValue ?? null);
    } else {
      const childrenIds: Array<IFormBase['fieldId']> =
        conditionalParentFields[fieldId];

      setHasAnyValue(
        childrenIds.some(
          childId => conditionalChildFields[childId].hasAnyValue,
        ),
      );
    }
  }, [fieldId, conditionalParentFields, conditionalChildFields]);

  return hasAnyValue;
};
